export default {"src":"/_next/static/media/logo-hd.93fcd486.svg","height":120,"width":270,"blurWidth":0,"blurHeight":0};